<style lang="less" scoped>
.margin-tb {
  height: 32px;
  margin-top: 4px;
}

.query-title-div {
  width: 90px !important;
}
.proportion-List {
  width: 100%;
  height: 46px;
  border-radius: 16px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  overflow: hidden;
  div {
    // width: 30%;
    height: 100%;
    &:nth-child(1) {
      background-color: #9fdbdb;
    }
    &:nth-child(2) {
      background-color: #00ddd9;
    }
    &:nth-child(3) {
      background-color: #00ccf3;
    }
    &:nth-child(4) {
      background-color: #0094db;
    }
    &:nth-child(5) {
      background-color: #00558e;
    }
  }
}
.topList {
  height: 175px;
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-top: 20px;
  .topList-div {
    width: 18%;
    height: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    // background-color: #4182eb;
    border-radius: 22px;
    padding: 20px;
    &:nth-child(1) {
      background-color: #9fdbdb;
    }
    &:nth-child(2) {
      background-color: #00ddd9;
    }
    &:nth-child(3) {
      background-color: #00ccf3;
    }
    &:nth-child(4) {
      background-color: #0094db;
    }
    &:nth-child(5) {
      background-color: #00558e;
    }
    div {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      &:first-child {
        width: 35%;
        padding: 10px;
        // text-align: center;
        height: 80%;
        color: white;
        font-weight: 600;
        justify-content: flex-start;
        p:nth-child(1) {
          width: 38px;
          height: 38px;
          background-color: white;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
      &:last-child {
        flex: 1;
        height: 80%;
        // border-left: 1px solid rgba(255, 255, 255, 0.404);
        color: white;
        p {
          display: flex;
          justify-content: flex-end;
          align-items: center;
          padding: 0 10px;
          box-sizing: border-box;
          &:nth-child(1),
          &:nth-child(3) {
            font-size: 13px;
          }
          &:nth-child(2),
          &:nth-child(4) {
            font-size: 23px;
          }
        }
      }
    }
  }
  .topList-div3 {
    width: 30%;
    height: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    background-color: #4182eb;
    border-radius: 22px;
    div {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: flex-start;
      // text-align: center;
      &:first-child {
        width: 50%;
        padding: 10px;
        // text-align: center;
        height: 80%;
        color: white;
        font-weight: 600;
        border-right: 1px solid rgba(255, 255, 255, 0.404);
        padding: 20px;
        box-sizing: border-box;
        p:nth-child(1) {
          width: 38px;
          height: 38px;
          background-color: white;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        p:nth-child(3) {
          font-size: 23px;
        }
      }
      &:last-child {
        width: 50%;
        padding: 10px;
        // text-align: center;
        height: 80%;
        color: white;
        font-weight: 600;
        padding: 20px;
        box-sizing: border-box;
        p:nth-child(1) {
          width: 38px;
          height: 38px;
          background-color: white;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        p:nth-child(3) {
          font-size: 23px;
        }
      }
    }
  }
}
.reportDiv {
  width: 100%;
  height: 600px;
  overflow: auto;
  // padding: 20px;
  border: 1px solid #e6e8ef;
  margin-top: 20px;
  border-radius: 7px;
  .topTitle {
    font-size: 16px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    color: #2c2f4b;
    line-height: 22px;
  }
  .reportDiv-List {
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
    .top-title {
      display: flex;

      align-items: center;
      .top {
        display: flex;
        div {
          width: 200px;
          font-size: 16px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          color: #8f9bb3;
          &:last-child {
            font-size: 20px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            color: #4182eb;
            letter-spacing: 1px;
          }
        }
      }
    }

    .list {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .list-left {
        width: 10%;
        // border: 1px solid #e6e8ef;
        border-radius: 14px;
        height: 340px;
        overflow: hidden;
        div:last-child {
          p {
            display: flex;
            justify-content: space-around;
            align-items: center;
            font-size: 16px;
            height: 26px;
            line-height: 26px;
            margin: 34px 0;
            span:nth-child(1) {
              display: block;
              width: 40%;
            }
            span:nth-child(2) {
              display: block;
              width: 20%;
            }
            span:nth-child(3) {
              display: block;
              width: 20%;
            }
          }
        }
      }
      .list-right {
        width: 90%;
        height: 410px;
        // border: 1px solid #e6e8ef;
        border-radius: 14px;
        overflow: hidden;
        .registration-trends {
          width: 100%;
          height: 100%;
        }
      }
    }
    .to-List {
      width: 100%;
      // height: 60px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
  }
}
.reportDiv-List3 {
  width: 100%;
  padding: 20px 0;
  .list {
    display: flex;
    justify-content: space-between;
    align-content: center;
    .list-left {
      width: 49%;
      border: 1px solid #e6e8ef;
      border-radius: 14px;
      height: 458px;
      overflow: hidden;
      .top {
        width: 100%;
        // height: 50px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px;
        div {
          // width: 200px;
          font-size: 16px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          color: #8f9bb3;
          &:last-child {
            font-size: 20px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            color: #4182eb;
            letter-spacing: 1px;
          }
        }
      }
      .registration-trends {
        width: 100%;
        height: 257px;
      }
      .to-List {
        width: 100%;
        // height: 60px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding: 0 20px;
      }
    }
    .list-right {
      width: 49%;
      height: 458px;
      border: 1px solid #e6e8ef;
      border-radius: 14px;
      overflow: hidden;
      .top {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px;
        div {
          // width: 200px;
          font-size: 16px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          color: #8f9bb3;
          &:last-child {
            font-size: 20px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            color: #4182eb;
            letter-spacing: 1px;
          }
        }
      }
      .registration-trends {
        width: 100%;
        height: 247px;
      }
      .to-List {
        width: 100%;
        // height: 60px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding: 0 20px;
      }
    }
  }
}

.blue {
  background: #4182eb !important;
  color: white !important;
  border: none;
}
.gray {
  background: #e7e7e8 !important;
  border: none;
  color: #9ba5ba;
  // color: white !important;
}
</style>

<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="list-content-div">
      <div class="list-header-title" style="width:100%;display:flex;justify-content:space-between;font-size:26px;color:#000000;">
        用户类型统计
        <el-button type="primary" @click="toSetList">数据列表</el-button>
      </div>
      <div class="proportion-List">
        <div
          v-for="(item, index) in proportionList"
          :key="index"
          :style="{ width: item + '%' }"
        ></div>
      </div>
      <div class="topList">
        <div class="topList-div">
          <div>
            <p>
              <img :src="topList[0].img" alt="" />
            </p>
          </div>
          <div>
            <p>
              {{ topList[0].title }}
            </p>
            <p>
              {{ topList[0].bookCount | numberToCurrency}}
            </p>
            <p>
              {{ topList[0].name }}
            </p>
            <p>
              {{ topList[0].bookRatio |numFilter}}
            </p>
          </div>
        </div>
        <div class="topList-div">
          <div>
            <p>
              <img :src="topList[1].img" alt="" />
            </p>
          </div>
          <div>
            <p>
              {{ topList[1].title }}
            </p>
            <p>
              {{ topList[1].remoteCount | numberToCurrency}}
            </p>
            <p>
              {{ topList[1].name }}
            </p>
            <p>
              {{ topList[1].remoteRatio |numFilter}}
            </p>
          </div>
        </div>
        <div class="topList-div">
          <div>
            <p>
              <img :src="topList[2].img" alt="" />
            </p>
          </div>
          <div>
            <p>
              {{ topList[2].title }}
            </p>
            <p>
              {{ topList[2].plugAndPlayCount | numberToCurrency}}
            </p>
            <p>
              {{ topList[2].name }}
            </p>
            <p>
              {{ topList[2].plugAndPlayRatio |numFilter}}
            </p>
          </div>
        </div>
        <div class="topList-div">
          <div>
            <p>
              <img :src="topList[3].img" alt="" />
            </p>
          </div>
          <div>
            <p>
              {{ topList[3].title }}
            </p>
            <p>
              {{ topList[3].bluetoothCount | numberToCurrency}}
            </p>
            <p>
              {{ topList[3].name }}
            </p>
            <p>
              {{ topList[3].bluetoothRatio |numFilter}}
            </p>
          </div>
        </div>
        <div class="topList-div">
          <div>
            <p>
              <img :src="topList[4].img" alt="" />
            </p>
          </div>
          <div>
            <p>
              {{ topList[4].title }}
            </p>
            <p>
              {{ topList[4].otherCount | numberToCurrency}}
            </p>
            <p>
              {{ topList[4].name }}
            </p>
            <p>
              {{ topList[4].otherRatio |numFilter}}
            </p>
          </div>
        </div>
      </div>
      <!-- 报表 -->
      <div class="reportDiv">
        <div class="topTitle">
          <div>上月充电桩充电订单分布</div>
        </div>

        <!-- 充电桩绑定数 -->
        <div class="reportDiv-List">
          <div class="top-title">
            <div class="top">
              <div>前5充电桩订单总数</div>
              <div>
                <span>{{
                  detailInfo.productOrderDistributeDto.orderCount| numberToCurrency
                }}</span>
              </div>
            </div>
            <div class="top">
              <div>前5充电桩订单占比</div>
              <div>
                <span
                  >{{ detailInfo.productOrderDistributeDto.orderRatio|numFilter }}%</span
                >
              </div>
            </div>
          </div>

          <div class="list">
            <div class="list-left">
              <div>
                <p v-for="(item, index) in pileCodeList" :key="index">
                  {{ item }}
                </p>
              </div>
            </div>
            <div class="list-right">
              <div class="registration-trends" id="RegistrationTrends"></div>
            </div>
          </div>
          <div class="to-List">
            <el-button type="primary" @click="toChargingOrders"
              >数据列表</el-button
            >
          </div>
        </div>
      </div>

      <!--充电订单总数数 -->
      <div class="reportDiv-List3">
        <div class="list">
          <div class="list-left">
            <div class="topTitle">
              <div>{{detailInfo.pileOrderDto.statisDate?detailInfo.pileOrderDto.statisDate:''}}</div>
              <div>
                <el-button
                  :class="daysChange ? 'blue' : 'gray'"
                  type="primary"
                  @click="handleDateChange"
                  round
                  >近七天</el-button
                >
                <el-button
                  :class="!daysChange ? 'blue' : 'gray'"
                  type="primary"
                  @click="handleDateChange"
                  round
                  >近三十天</el-button
                >
              </div>
            </div>
            <div class="top">
              <div>充电订单总数</div>
              <div><span>{{detailInfo.pileOrderDto.orderCountAll| numberToCurrency}}</span></div>
            </div>
            <div class="registration-trends" id="activeUsers"></div>
            <div class="to-List">
              <el-button type="primary" @click="toChargingOrdersTimePeriods"
                >数据列表</el-button
              >
            </div>
          </div>
          <div class="list-right">
            <div class="topTitle">
              <div>{{detailInfo.chargeValueDto.statisDate}}</div>
              <div>
                <el-button
                  :class="daysChange ? 'blue' : 'gray'"
                  type="primary"
                  @click="handleChargeValueChange"
                  round
                  >近七天</el-button
                >
                <el-button
                  :class="!daysChange ? 'blue' : 'gray'"
                  type="primary"
                  @click="handleChargeValueChange"
                  round
                  >近三十天</el-button
                >
              </div>
            </div>
            <div class="top">
              <div>充电总电量</div>
              <div><span>{{detailInfo.chargeValueDto.chargeValueCountAll| numberToCurrency}}</span></div>
            </div>
            <div class="registration-trends" id="antEnergy"></div>
            <div class="to-List">
              <el-button type="primary" @click="toChargingCapacity"
                >数据列表</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageConfig from "./page-config";
import { EleResize } from "../../../../config/esresize";
import * as echarts from "echarts";
import img1 from "../../../../assets/operationalData/人数1.png";
import img2 from "../../../../assets/operationalData/人数2.png";
import img3 from "../../../../assets/operationalData/人数3.png";
import img4 from "../../../../assets/operationalData/人数4.png";
import img5 from "../../../../assets/operationalData/人数5.png";
export default {
  data() {
    return {
      pageConfig: pageConfig, // 页面配置
      daysChange: true,
      ChargeValueChange: true,
      detailInfo: {
        productOrderDistributeDto: {
          materialNo: "",
          orderCount: "",
          orderRatio: "",
          showName: "",
        },
        pileOrderDto: {
          orderCountAll: "",
          statisDate: "",
        },
        chargeValueDto: {
          chargeValueCountAll: "",
          statisDate: "",
        },
        productOrderDistributeList: [],
        pileOrderList: [],
        chargeValueList: [],
      },
      // 充电订单列表
      pileOrderTypeChargeCountAll: [],
      pileOrderTypeNames: [],
      // 时段分布列表
      pileOrderChargeCountAll: [],
      pileOrderCountFir: [],
      pileOrderStatisDate: [],
      // 充电电量
      chargeValueCountAll: [],
      chargeValueCountFir: [],
      chargeValueStatisDate: [],
      topList: [
        {
          img: img1,
          title: "预约充电设置人数",
          bookCount: "",
          name: "占比",
          bookRatio: "",
        },
        {
          img: img2,
          title: "远程启停设置人数",
          remoteCount: "",
          name: "占比",
          remoteRatio: "" ,
        },
        {
          img: img3,
          title: "即插即充设置人数",
          plugAndPlayCount: "",
          name: "占比",
          plugAndPlayRatio: "" ,
        },
        {
          img: img4,
          title: "蓝牙无感设置人数",
          bluetoothCount: "",
          name: "占比",
          bluetoothRatio: "" ,
        },
        {
          img: img5,
          title: "其他设置人数",
          otherCount: "",
          name: "占比",
          otherRatio: "" ,
        },
      ],
      proportionList: [],
      pileCodeList: [
       
      ],
    };
  },
  methods: {
    // 判断页面路由是否存在手机号码/站点编号
    init() {
      // 获取用户注册趋势
      // this.getRegistrationTrends();

      this.proportionList[0] = this.topList[0].bookRatio;
      this.proportionList[1] = this.topList[1].remoteRatio;
      this.proportionList[2] = this.topList[2].plugAndPlayRatio;
      this.proportionList[3] = this.topList[3].bluetoothRatio;
      this.proportionList[4] = this.topList[4].otherRatio;
      console.log(this.proportionList);
    },
    //选择系统日期时间

    handleDateChange(val) {
      console.log(this.daysChange);
      this.daysChange = !this.daysChange;
      this.getPileOrder();
    },
    handleChargeValueChange(val) {
      this.ChargeValueChange = !this.ChargeValueChange;
      this.getChargeValue();
    },
    getWeek() {
      let time = new Date().getTime();
      let endTime = time - 6 * 24 * 3600 * 1000;
      this.startDate = this.$dayjs(endTime).format("YYYY-MM-DD");
      this.endDate = this.$dayjs(time).format("YYYY-MM-DD");
      console.log(this.startDate); // 开始时间
      console.log(this.endDate); // 结束时间
    },
    getMonth() {
      let time = new Date().getTime();
      let now = new Date(); // 当前日期
      let nowMonth = now.getMonth(); // 当前月
      let nowYear = now.getFullYear(); // 当前年
      let monthStartDate = new Date(nowYear, nowMonth, 1);
      let monthEndDate = new Date(nowYear, nowMonth + 1, 0);
      this.startDate = this.$dayjs(monthStartDate).format("YYYY-MM-DD");
      this.endDate = this.$dayjs(monthEndDate).format("YYYY-MM-DD");
    },
    getData() {
      let _ = this;
      if (this.daysChange) {
        this.getWeek();
      } else {
        this.getMonth();
      }
      let obj = {
        startDate: _.startDate,
        endDate: _.endDate,
        filterType: "01",
      };
      _.$H.post(_, _.$A.operateStatis.custHabit, obj).then((res) => {
        _.detailInfo = res.data.data;
        _.topList[0].bookCount = _.detailInfo.custHabitDto.bookCount;
        _.topList[0].bookRatio = _.detailInfo.custHabitDto.bookRatio;
        _.topList[1].remoteCount = _.detailInfo.custHabitDto.remoteCount;
        _.topList[1].remoteRatio = _.detailInfo.custHabitDto.remoteRatio;
        _.topList[2].plugAndPlayCount =
          _.detailInfo.custHabitDto.plugAndPlayCount;
        _.topList[2].plugAndPlayRatio =
          _.detailInfo.custHabitDto.plugAndPlayRatio;
        _.topList[3].bluetoothCount = _.detailInfo.custHabitDto.bluetoothCount;
        _.topList[3].bluetoothRatio = _.detailInfo.custHabitDto.bluetoothRatio;
        _.topList[4].otherCount = _.detailInfo.custHabitDto.otherCount;
        _.topList[4].otherRatio = _.detailInfo.custHabitDto.otherRatio;
        _.init();
        // 充电订单类型
        _.pileCodeList = [];
        _.detailInfo.productOrderDistributeList.forEach((item) => {
          _.pileOrderTypeChargeCountAll.push(item.orderCount);
          _.pileOrderTypeNames.push(item.showName);
          _.pileCodeList.push(item.materialNo);
        });
        _.getRegistrationTrends();
      });
      let orderObj = {
        startDate: _.startDate,
        endDate: _.endDate,
        filterType: "01",
      };
      _.$H.post(_, _.$A.operateStatis.pileOrderChart, orderObj).then((res) => {
        _.detailInfo = res.data.data;
        // 充电订单时段
        _.detailInfo.pileOrderList.forEach((item) => {
          _.pileOrderChargeCountAll.push(item.orderCountAll);
          _.pileOrderCountFir.push(item.orderCountFir);
          _.pileOrderStatisDate.push(item.statisDate);
        });
        console.log(_.pileOrderStatisDate);
        _.getActiveUsers();
      });

      let chargeObj = {
        startDate: _.startDate,
        endDate: _.endDate,
        filterType: "01",
      };
      _.$H
        .post(_, _.$A.operateStatis.chargeValueChart, chargeObj)
        .then((res) => {
          _.detailInfo = res.data.data;
          // 充电电量
          _.detailInfo.chargeValueList.forEach((item) => {
            _.chargeValueCountAll.push(item.chargeValueCountAll);
            _.chargeValueCountFir.push(item.chargeValueCountFir);
            _.chargeValueStatisDate.push(item.statisDate);
          });

          _.getAntEnergy();
        });
    },
    getPileOrder() {
      let _ = this;
      if (this.daysChange) {
        this.getWeek();
      } else {
        this.getMonth();
      }
      let obj = {
        startDate: _.startDate,
        endDate: _.endDate,
        filterType: "01",
      };
      _.$H.post(_, _.$A.operateStatis.pileOrderChart, obj).then((res) => {
        _.pileOrderStatisDate = [];
        // 充电订单时段
          _.pileOrderCountFir[0] = res.data.data.pileOrderDto.orderCountFir;
          _.pileOrderCountFir[1] = res.data.data.pileOrderDto.orderCountSec;
          _.pileOrderCountFir[2] = res.data.data.pileOrderDto.orderCountThi;
          _.pileOrderCountFir[3] = res.data.data.pileOrderDto.orderCountFou;
          _.pileOrderCountFir[4] = res.data.data.pileOrderDto.orderCountFiv;
          _.pileOrderCountFir[5] = res.data.data.pileOrderDto.orderCountSix;
          _.pileOrderCountFir[6] = res.data.data.pileOrderDto.orderCountSev;
          _.pileOrderCountFir[7] = res.data.data.pileOrderDto.orderCountEig;
          _.pileOrderCountFir[8] = res.data.data.pileOrderDto.orderCountNin;
          _.pileOrderCountFir[9] = res.data.data.pileOrderDto.orderCountTen;
          _.pileOrderCountFir[10] = res.data.data.pileOrderDto.orderCountEle;
          _.pileOrderCountFir[11] = res.data.data.pileOrderDto.orderRatioTwe;
         
          _.pileOrderStatisDate.push(item.statisDate);
        });
        _.getActiveUsers();
    
    },
    getChargeValue() {
      let _ = this;
      if (this.ChargeValueChange) {
        this.getWeek();
      } else {
        this.getMonth();
      }
      let obj = {
        startDate: _.startDate,
        endDate: _.endDate,
        filterType: "01",
      };
      _.chargeValueStatisDate = [];
      _.$H.post(_, _.$A.operateStatis.chargeValueChart, obj).then((res) => {
        // 充电电量
        _.detailInfo.chargeValueList.forEach((item) => {
          _.chargeValueCountAll.push(item.chargeValueCountAll);
          _.chargeValueCountFir.push(item.chargeValueCountFir);
          _.chargeValueStatisDate.push(item.statisDate);
        });
        _.getAntEnergy();
      });
    },
    toChargingOrders() {
      let _ = this;
      var url = _.$router.resolve({
        name: "chargingOrders",
        query: { id: "val" },
      });
      window.open(url.href, "_blank");
    },
    toChargingOrdersTimePeriods() {
      let _ = this;
      var url = _.$router.resolve({
        name: "chargingOrdersTimePeriods",
        query: { daysChange: _.daysChange },
      });
      window.open(url.href, "_blank");
    },
    toChargingCapacity() {
      let _ = this;
      var url = _.$router.resolve({
        name: "chargingCapacity",
        query: { ChargeValueChange: _.ChargeValueChange },
      });
      window.open(url.href, "_blank");
    },
    toSetList() {
      let _ = this;
      var url = _.$router.resolve({
        name: "chargingSettings",
        query: {  },
      });
      window.open(url.href, "_blank");
    },
    //表格详情
    toDetail(val) {
      let _ = this;
      var url = _.$router.resolve({ name: "orderDetail", query: { id: val } });
      window.open(url.href, "_blank");
    },
    // 充电订单类型
    getRegistrationTrends() {
      // 基于准备好的dom，初始化echarts实例
      let changeChart = this.$echarts.init(
        document.getElementById("RegistrationTrends")
      );
      // 绘制图表
      changeChart.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        xAxis: {
          type: "value",

          max: 9000, //最大值
          min: 0, //最小值
          interval: 4500, //间隔
          //     axisLabel: {//坐标轴刻度标签
          // 	show: false
          // },
          axisLine: {
            //坐标轴轴线
            show: false,
          },
          axisTick: {
            //坐标轴刻度
            show: false,
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed",
              color: "#e6e9ee",
            },
          },
        },
        yAxis: {
          type: "category",
          //     axisLabel: {//坐标轴刻度标签
          // 	show: false
          // },
          axisLine: {
            //坐标轴轴线
            show: false,
          },
          axisTick: {
            //坐标轴刻度
            show: false,
          },
          data: this.pileOrderTypeNames,
        },
        series: [
          {
            type: "bar",
            barWidth: 25, //柱子宽度
            barGap: 3, //柱子间距
            label: {
              normal: {
                show: true,
                position: "top",
              },
            },

            itemStyle: {
              normal: {
                color: function(params) {
                  let colorList = [
                    ["#f8822a", "#facd5a"],
                    ["#58bdff", "#b780f2"],
                    ["#717ef2", "#ed618b"],
                    ["#0fa7e7", "#5ecc60"],
                    ["#63b2ed", "#13c3d0"],
                  ];
                  console.log(colorList[params.dataIndex]);
                  let colorItem = colorList[params.dataIndex];
                  return new echarts.graphic.LinearGradient(
                    0,
                    0,
                    1,
                    0, //y->y2
                    [
                      {
                        offset: 0,
                        color: colorItem[0],
                      },
                      {
                        offset: 1,
                        color: colorItem[1],
                      },
                    ],
                    false
                  );
                },
                barBorderRadius: [0, 30, 30, 0],
                // shadowColor: 'rgba(0,160,221,1)',
                // shadowBlur: 4,
              },
            },

            data: this.pileOrderTypeChargeCountAll,
          },
        ],
      });
      setTimeout(() => {
        window.addEventListener("resize", function() {
          changeChart.resize();
        });
      }, 500);
    },

    // 充电订单
    getActiveUsers() {
      // 基于准备好的dom，初始化echarts实例
      let changeChart = this.$echarts.init(
        document.getElementById("activeUsers")
      );
      // 绘制图表
      changeChart.setOption({
        tooltip: {
          trigger: "axis",
          // backgroundColor:'transparent',
          axisPointer: {
            lineStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "#ffdfdf", // 0% 处的颜色
                  },
                  {
                    offset: 0.5,
                    color: "#ffa4a4", // 100% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#ff8383", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
          },
        },
        xAxis: {
          type: "category",
          axisLine: {
            show: false,
          },
          data: ['00:00','02:00','04:00','06:00','08:00','10:00','12:00','14:00','16:00','18:00','20:00','22:00'],
        },
        yAxis: {
          type: "value",
          max: 1000, //最大值
          min: 0, //最小值
          interval: 500, //间隔

          //坐标轴最大值、最小值、强制设置数据的步长间隔
          // interval: 5,
          // axisLabel: {
          //     //y轴上带的单位
          //     formatter: '{value}'
          // },
          //轴线
          axisLine: {
            show: true,
          },
          // //分割线
          // splitLine: {
          //     show: false
          // }
        },
        series: [
          {
            data: this.pileOrderChargeCountAll,
            type: "line",
            // showSymbol: false,
            symbolSize: 3,
            symbol: "circle",
            itemStyle: {
              normal: {
                color: "#ff8383", //改变折线点的颜色
                lineStyle: {
                  color: "#ff8383", //改变折线颜色
                },
              },
            },
          },
        ],
      });
      setTimeout(() => {
        window.addEventListener("resize", function() {
          changeChart.resize();
        });
      }, 500);
    },
    // 充电电量
    getAntEnergy() {
      // 基于准备好的dom，初始化echarts实例
      let changeChart = this.$echarts.init(
        document.getElementById("antEnergy")
      );
      // 绘制图表
      changeChart.setOption({
        tooltip: {
          trigger: "axis",
          // backgroundColor:'transparent',
          axisPointer: {
            lineStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "#ecfced", // 0% 处的颜色
                  },
                  {
                    offset: 0.5,
                    color: "#c5f7c6", // 100% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#19de1f", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
          },
        },
        xAxis: {
          type: "category",
          axisLine: {
            show: false,
          },
          data: this.chargeValueCountAll,
        },
        yAxis: {
          type: "value",
          max: 1000, //最大值
          min: 0, //最小值
          interval: 500, //间隔

          //坐标轴最大值、最小值、强制设置数据的步长间隔
          // interval: 5,
          // axisLabel: {
          //     //y轴上带的单位
          //     formatter: '{value}'
          // },
          //轴线
          axisLine: {
            show: true,
          },
          // //分割线
          // splitLine: {
          //     show: false
          // }
        },
        series: [
          {
            data: this.chargeValueCountAll,
            type: "line",
            // showSymbol: false,
            symbolSize: 3,
            symbol: "circle",
            itemStyle: {
              normal: {
                color: "#19de1f", //改变折线点的颜色
                lineStyle: {
                  color: "#19de1f", //改变折线颜色
                },
              },
            },
          },
        ],
      });
      setTimeout(() => {
        window.addEventListener("resize", function() {
          changeChart.resize();
        });
      }, 500);
    },

    // echarts 实例
    drawECharts(dom, option) {
      let myChart = this.$echarts.init(document.getElementById(dom));
      let resizeDiv = document.getElementById(dom);
      resizeDiv.removeAttribute("_echarts_instance_");
      // 绘制图表
      myChart.setOption(option);
      let listener = () => {
        myChart.resize();
      };
      EleResize.on(resizeDiv, listener);
    },
  },
  mounted() {
    this.getData();
    // this.init();
    this.getRegistrationTrends();

    this.getActiveUsers();
    this.getAntEnergy();
  },
};
</script>
